import { faPuzzle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip, IconButton } from '@mui/material';
import { useState } from 'react';

import './styles.scss';

import { Dropdown } from '../../../../../components/dropdown/dropdown';
import { Radio } from '../../../../../components/radio';
import { TradeParamsEnum, TRADES_PARAMS_LABELS } from '../../../trade-models';

const optionKeys = [
  TradeParamsEnum.spot,
  TradeParamsEnum.vol,
  TradeParamsEnum.forward,
  TradeParamsEnum.discount_factor,
];

const options = TRADES_PARAMS_LABELS.filter((item) => optionKeys.includes(item.key)).map(
  (item) => ({
    label: item.label,
    value: item.key,
  }),
);

interface SolveButtonProps {
  hasSolveItems: boolean;
  onSolve: (param: TradeParamsEnum) => void;
}

const SolveButton = ({ hasSolveItems, onSolve }: SolveButtonProps) => {
  const [open, setOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<TradeParamsEnum | null>(TradeParamsEnum.vol);

  const handleRadioChange = (value: TradeParamsEnum) => {
    setSelectedOption(value);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedOption(TradeParamsEnum.vol);
  };

  return (
    <div className="solve-button">
      <Tooltip title="Solve">
        <span>
          <IconButton
            className="action-button"
            onClick={() => {
              setOpen((prev) => !prev);
            }}
            disabled={!hasSolveItems}
          >
            <FontAwesomeIcon icon={faPuzzle} className="icon" />
          </IconButton>
        </span>
      </Tooltip>
      <Dropdown isOpen={open} setIsOpen={setOpen} classNames="dropdown" onClose={handleClose}>
        <div className="menu-container">
          <span className="dropdown-title">Select the market parameter you want to discover:</span>
          <div className="dropdown-options">
            {options.map((option) => (
              <div key={option.value} className="dropdown-option">
                <Radio
                  label={option.label}
                  checked={selectedOption === option.value}
                  onChange={() => handleRadioChange(option.value)}
                />
              </div>
            ))}
          </div>
          <div className="dropdown-buttons">
            <Button onClick={handleClose} className="dropdown-button cancel-button">
              Cancel
            </Button>
            <Button
              onClick={() => {
                if (selectedOption) {
                  onSolve(selectedOption);
                }
                handleClose();
              }}
              disabled={!selectedOption}
              className="dropdown-button confirm-button"
            >
              Resolve
            </Button>
          </div>
        </div>
      </Dropdown>
    </div>
  );
};

export default SolveButton;
